module.exports = __webpack_public_path__ + "03_mole.c6d0a8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/03_mole.png
// module id = KOtB
// module chunks = 0